import { adapter, initialState, State } from './contract.state'
import * as R from 'ramda'
import { LoadContractsComplete } from './contract.actions'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadContractsComplete, (state, { contracts }) => adapter.addAll(contracts, R.merge(state, { isLoaded: true })))
)

export function contractReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
